import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Spinner from "react-bootstrap/Spinner";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import Top from "../../components/Top";
import { API_BASE_URL } from "../../api/config";
import "../../index.css";

function TeamMember() {
  const { id } = useParams();

  const { isLoading, isError, data, error } = useQuery({
    queryKey: ["team-member", id],
    queryFn: async () => {
      const res = await fetch(
        `${API_BASE_URL}/api/user/team_members/${id}`
      );
      return await res.json();
    },
  });

  if (isLoading) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner
          animation="border"
          role="status"
          style={{ height: "89px", width: "89px" }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-3">Kindly be patient while we fetch your data</p>
      </div>
    );
  }

  if (isError) {
    return <p>An Error Occurred: {error.message}</p>;
  }

  return (
    <div className="team-member-page">
      <div className="container team-member-content">
        <Link to="/team" className="team-back-link mb-4 d-inline-block">
          &larr; Back to Team
        </Link>
        <div className="row mt-3">
          <div className="col-12 col-md-4 mb-4">
            <img
              src={
                data?.profile_image
                  ? `${API_BASE_URL}/${data.profile_image}`
                  : "https://via.placeholder.com/400x400?text=No+Photo"
              }
              alt={`${data?.first_name} ${data?.last_name}`}
              className="team-member-img"
            />
          </div>
          <div className="col-12 col-md-8">
            {data?.title && (
              <small className="text-muted">{data.title}</small>
            )}
            <h2 className="team-member-name">
              {data?.first_name} {data?.last_name}
            </h2>
            <h5 className="team-member-position">{data?.position}</h5>
            {data?.summary && (
              <p className="team-member-summary">{data.summary}</p>
            )}
          </div>
        </div>
        {data?.description && (
          <div className="team-member-description mt-4">
            {parse(
              DOMPurify.sanitize(data.description, {
                USE_PROFILES: { html: true },
              })
            )}
          </div>
        )}
      </div>
      <Top />
    </div>
  );
}

export default TeamMember;
